import EtablissementLogo from '@/generated/controls/etablissement/EtablissementLogo.vue';
import { GenControl, RessourceGenControl } from '@/generated/ressources/generatedRessources';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementLogo,
    computed: {
        ressource () {
            return { ...RessourceGenControl(GenControl.ETABLISSEMENT_LOGO), label: 'Logo' };
        },
    },
})
